// In App navigatio component to create modals

import { Injectable } from '@angular/core';
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, MenuController, ModalController, Platform, PopoverController } from '@ionic/angular';
import type { PopoverSize } from '@ionic/core';

import { checkRoutesName, stringToClass } from './factory';
import { EventsService } from 'src/app/services/event/event.service';
import { MenuStateService } from 'src/app/services/sidemenu/menu-state.service';
import { NavigationOptions } from 'src/app/interfaces/navigation-interface'
import { PopoverClass } from 'src/app/popovers/popover-factory';
import { RoutingService } from './routing.service';

@Injectable({
	providedIn: 'root',
})

export class Navigator {

	private modalStack: any[] = [];
	public activeLobbyTabName: string = 'casino';
	public activeModals: HTMLIonModalElement[] = [];
	public activePage: any = '';
	public activePopovers: HTMLIonPopoverElement[] = [];
	public currentPage = null;
	public currentTab: string;
	public isMobileApp: boolean = false;
	public modal: any;
	public storeCasinoKeywordRoute: string = '';
	public storeExtCategroyRoute: string;
	public storeWPLinkCode: string = '';
	public waitingModal: string = null;
	public waitingModalParams: any;

	constructor(
		private activateRouter: ActivatedRoute,
		private alertController: AlertController,
		private events: EventsService,
		private location: Location,
		private menuCtrl: MenuController,
		private menuStateService: MenuStateService,
		private modalCtrl: ModalController,
		private platform: Platform,
		private popoverController: PopoverController,
		private router: Router,
		private routing: RoutingService,
	) { }

	public navigateTo(pageName, options?: any, params?: any, menuSide?) {
		setTimeout(() => {
			this.currentPage = null;
		}, 1000);
		if (this.currentPage === pageName) {
			console.log("Page already opened")
			return
		}
		if (!this.currentPage) this.currentPage = pageName;
		let page = stringToClass(pageName);
		let pageParams = (typeof params !== "undefined") ? params : "";
		let ModalOptions: NavigationOptions = this.getOptions(options);

		if (pageName === 'PlayerDashboardComponent') {
			ModalOptions.customModalClass += ' player-dashboard'
		}
		//get the modal route with friendly path
		let modalRoute = checkRoutesName(pageName);

		if (this.activeModals.length && !ModalOptions.multipleModals) {
			this.dismissAll();
		}
		this.openModal(page, pageName, ModalOptions, pageParams, menuSide).then(() => this.sendHistoryEvent(modalRoute));
	}

	async openModal(page: any, pageName, ModalOptions?: any, params?: any, menuSide?) {

		const backdropDismissFlag: boolean = (typeof ModalOptions.backdropDismiss === "undefined") ? false : ModalOptions.backdropDismiss;
		const customClass: string = (typeof ModalOptions.customModalClass === "undefined") ? 'custom-modal-class' : ModalOptions.customModalClass;

		const modal = await this.modalCtrl.create({
			component: page,
			componentProps: params,
			cssClass: customClass,
			animated: true,
			backdropDismiss: backdropDismissFlag,
		});
		this.activeModals.push(modal);
		this.modalStack.push(pageName);

		this.activePage = pageName;

		//To match the modal component route path logic - removing 9 characters from {modal}component
		let componenetName = pageName.substr(0, pageName.length - 9)
		let componenetRouteName = componenetName.toLowerCase();
		this.router.navigate([`/${componenetRouteName}`], { relativeTo: this.activateRouter });

		this.menuStateService.openSidemenu(menuSide);
		return await modal.present();
	}

	private getOptions(options: NavigationOptions) {
		let ModalOptions: NavigationOptions = {};

		if (typeof options === "undefined") {
			return ModalOptions = {
				multipleModals: false,
				backdropDismiss: false,
				customModalClass: 'custom-modal-class',
				callback: null
			}
		}

		ModalOptions.multipleModals = (typeof options.multipleModals === "undefined") ? false : options.multipleModals;
		ModalOptions.backdropDismiss = (typeof options.backdropDismiss === "undefined") ? false : options.backdropDismiss;
		ModalOptions.customModalClass = (typeof options.customModalClass === "undefined") ? 'custom-modal-class' : options.customModalClass;
		ModalOptions.callback = (typeof options.callback === "undefined") ? null : options.callback;
		return ModalOptions;
	}

	readDeviceOrientation() {
		if (Math.abs(window.orientation) === 90) {
			// Landscape
			return "portrait-landscape";
		} else {
			// Portrait
			return "portrait-primary";
		}
	}

	async openPopover(
		popoverName: string = '',
		data: any = {},
		popoverStyle: string = '',
		backdropDismiss: boolean = true,
		animated: boolean = true,
		showBackdrop: boolean = true,
		closeTimer: number = -1,
		size: PopoverSize = 'cover', // by default ion-popver uses 'auto', but auto' is not good for here,
		onDefaultCenter: boolean = true
	) {
		if (!popoverName) {
			console.log(`popover name cannot be blank -- ${popoverName}`);
			return;
		}

		this.isMobileApp = this.platform.is('capacitor');
		let popoverPage = PopoverClass(popoverName);

		//if(this.isMobileApp){
		//popoverStyle = popoverStyle+' mobile-popover';
		//}
		if ((this.platform.is("capacitor") || this.platform.is("mobileweb")) && popoverName == "PopoverReconfirmation") {
			popoverStyle += " reconfirmation-mobile";
		}
		if ((this.platform.is("capacitor") || this.platform.is("mobileweb")) && popoverName == "PopoverSessionStats") {
			popoverStyle += " session-stats-mobile";
		}
		if (this.platform.is('ipad') && (popoverName == "VipTermsComponent" || popoverName == "PopoverAlertComponent")) {
			popoverStyle += " content-vipterm";
			popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " content-vipterm-ipad-web-portait" : " content-vipterm-ipad-web-landscape";
		} else {
			if (this.isMobileApp || this.platform.is('android') || this.platform.is('ios') || this.platform.is('ipad')) {
				if (onDefaultCenter) {
					if (this.platform.is('ipad') && (popoverStyle.includes("game-history-details") || popoverStyle.includes("self-exclude"))) {
						popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " game-history-details-and-self-exclude-portait" : " game-history-details-and-self-exclude-landscape";
					} else if (this.isMobileApp) {
						if (popoverStyle.includes("self-exclude") || popoverStyle.includes("SessionStats") || popoverStyle.includes("livedealer")) {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-app" : " center-popover-from-landscape-app center-popover-from-landscape-app-wider";
						} else {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-app" : " center-popover-from-landscape-app";
						}
					} else {
						if (!this.platform.is('ios')) {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-app" : " center-popover-from-landscape-app";
						} else {
							popoverStyle += this.readDeviceOrientation() == 'portrait-primary' ? " center-popover-from-portait-web" : " center-popover-from-landscape-web";
						}
					}
				}
			}
		}

		if (!popoverPage) {
			return;
		}

		return await this.popoverController
			.create({
				component: popoverPage,
				componentProps: { data },
				animated,
				showBackdrop,
				backdropDismiss,
				cssClass: popoverStyle,
				size,
			}).then(popover => {
				this.activePopovers.push(popover);
				popover.present();
				if (closeTimer > 0) {
					setTimeout(() => {
						popover.dismiss();
						//below method should not be called as it's causing an issue for app-init queue to work properly.
						//this.dismiss();
					}, closeTimer)
				}
				popover.onDidDismiss().then(() => {
					this.activePopovers = this.activePopovers.filter(item => item.id !== popover.id);
				});
				return popover;
			});
	}

	public dismiss(keywordRoute?) {
		this.modalStack.pop();
		const modal = this.activeModals.pop();
		modal?.dismiss({
			dismissed: true,
		});
		this.modalCtrl.dismiss();
		this.navigateUserToLastActivePath();
		return this.activeModals.length > 0;
	}

	public dismissAll(keywordRoute?) {
		this.activeModals.forEach(modal => {
			modal.dismiss();
		});

		while (this.activePopovers.length > 0) {
			const popover = this.activePopovers.pop();
			popover.dismiss();
		}

		this.activeModals = [];
		this.activePopovers = [];
		this.modalStack = [];

		const popoverController = this.popoverController;
		popoverController.getTop()
			.then(popover => {
				if (popover) {
					popoverController.dismiss();
				}
			});

		const alertController = this.alertController;
		alertController.getTop()
			.then(alert => {
				if (alert) {
					alertController.dismiss();
				}
			});

		this.navigateUserToLastActivePath();
		return;
	}

	public back() {
		if (this.activeModals.length) {
			this.closeActiveModal();
		} else {
			this.modalCtrl.dismiss();
			this.router.navigateByUrl("/");
		}

		if (!this.activeModals.length) {
			this.menuStateService.isMenuOpen("main-menu").subscribe(res => {
				if (res === "main-menu") {
					this.menuCtrl.open("main-menu");
				}
			})
		}
	}

	private closeActiveModal() {
		let modal = this.activeModals[this.activeModals.length - 1];
		modal.dismiss();
		this.activeModals.pop();
		this.modalStack.pop();

		//Using Angular location to go back to previously activated route path for back button of modal component
		this.location.back();
		if (!this.activeModals.length) {
			this.menuStateService.isMenuOpen("secondary-menu").subscribe(res => {
				if (res === "secondary-menu") {
					this.menuCtrl.open("secondary-menu");
				}
			})
		}
	}

	public getActivePage() {
		return this.activePage;
	}

	public pushHistoryState(pathname) {
		let newurl = window.location.protocol + "//" + window.location.host + '/' + pathname + window.location.search + document.location.hash;
		history.pushState({ path: newurl }, '', newurl);
		this.events.publish("event:history:push", { url: newurl });
	}

	public navigateToCasinoReplacingHistory() {
		// When navigating to casino from the landing page, we want to replace the history entry instead of pushing a new one
		// This is to prevent the user from being able to navigate back to the landing page from the casino page by clicking the back button
		return this.router.navigate(['casino'], {
			replaceUrl: true // This replaces current history entry instead of pushing new one
		});
	}

	public toLandingPage(dismissModals?: boolean) {
		if (dismissModals) this.dismissAll();
		return this.router.navigate(['landing'], {
			replaceUrl: true  // This won't add landing to the history stack
		});
	}

	public toAgeVerificationModal(gameData?: any) {
		this.navigateTo(
			'AgeVerificationComponent',
			{
				customModalClass: 'age-verification-modal',
				backdropDismiss: false,
				multipleModals: false
			},
			{ gameData: gameData }
		);
	}

	private sendHistoryEvent(componentPath) {
		this.events.publish("event:history:push", { page: componentPath })
	}

	isOnLobby() {
		// let noNavigation = (!this.modalStack.length && this.navCtrl.length() === 1) ? true : false;
		let noNavigation = this.modalStack.length == 0;
		let menuIsOpen = true;
		if (!this.menuCtrl.hasOwnProperty("isOpen")) {
			if (this.menuCtrl.isOpen()) {
				menuIsOpen = false;
			}
		}
		return !(noNavigation && menuIsOpen) ? true : false;
	}

	public goBackOrExitApp() {
		if (this.activeModals && this.activeModals.length > 0) {
			this.closeActiveModal();
		} else {
			navigator['app'].exitApp();
		}
	}

	setCurrentActiveLobby(tabName) {
		this.activeLobbyTabName = tabName;
	}

	getCurrentActiveLobby() {
		return this.activeLobbyTabName;
	}

	setCurrentActiveRouteExtPath(extPath) {
		this.storeExtCategroyRoute = extPath;
	}

	getCurrentActiveRouteExtPath() {
		return this.storeExtCategroyRoute;
	}

	setWaitingModal(page, params?): void {
		this.waitingModal = page;
		this.waitingModalParams = params ?? undefined;
	}

	getWaitingModal() {
		return this.waitingModal;
	}

	getWaitingModalParams() {
		return this.waitingModalParams;
	}

	public navigateUserToLastActivePath() {
		const currentLobby = this.getCurrentActiveLobby();
		switch (currentLobby) {
			case 'article':
				this.routing.toWebviewTab(false, this.getCurrentActiveRouteExtPath());
				break;
			case 'casino':
				const path = this.getCurrentActiveRouteExtPath();
				if (path) {
					this.routing.toLobbyTab(path);
				} else {
					this.routing.toLobbyTab();
				}
				break;
			default:
				if (currentLobby) {
					this.routing.toRoute(currentLobby);
				} else {
					this.routing.defaultRoute();
				}
				break;
		}
	}
}
